<template>
  <div style="height: 100vh;">
    <div class="row font-weight-bold mx-0">
      <div class="pl-0" style="max-width: 13%; flex: 0 0 13%; display: flex; justify-content: center; background-color: #ffebd4;">
        <div class="button-container">
          <div class="button" style="padding: 8px 25px;">All</div>
          <div class="button" style="padding: 8px 15px;">
            <input @click="isUpdateAll=!isUpdateAll" type="checkbox">
          </div>
        </div>
      </div>

      <div class="col-md-8 col-lg-8 text-center">
        <h3 class="mt-3 font-weight-bold">{{selectedDay.name}}</h3>
      </div>
      <div class="col-md-2 col-lg-2 text-right">
        <img v-if="canDeleteSelectedDay" src="/img/delete.png" width="15" alt="Delete" @click="deleteDate" class="mt-4 mr-3" style="cursor: pointer">
      </div>
    </div>

    <div class="row mt-1 mx-0" style="position: relative; height: 87vh;">
      <!-- Day List -->
      <div class="col-md-2 position-relative pl-0 pr-1 mt-2" style="max-width: 13%; flex: 0 0 13%; height: 82vh;">
        <div class="day-list">
          <div
            v-for="(day, index) in days"
            :key="index"
            :class="['day-item', { active: isUpdateAll ? true : selectedDay.id == day.id }]"
            @click="selectDay(day)"
            >
            {{ day.name }}
          </div>
        </div>
      </div>

      <!-- Schedule Selector -->
      <div class="col-md-3 pl-0 pr-1" style="background-color: #fff;">
        <!-- <div class="section-card" style="background-color: #FFEBD4;">
          <div class="form-group d-flex mb-0" style="align-items: center; justify-content: space-between;">
            <label for="day-status" class="mb-0 font-weight-bold">Day</label>
            <select v-model="isDayOpen" id="day-status" class="form-control w-75 font-weight-bold text-center">
              <option value="Closed">Closed</option>
              <option value="Open">Open</option>
            </select>
          </div>
        </div> -->
        <div style="position: relative;background-color: #FFEBD4; height: 70vh;">
          <div class="mealTypes">
            <button v-for="(meal, i) in selectedDay.mealOfDays" :key="i"
              :class="[{ active: selectedMeal.mealType === meal.mealType }]"
              @click="selectMeal(meal)">{{meal.mealType}}
            </button>
          </div>
          <div class="row">
            <div class="col-md-12 d-flex" style="justify-content: space-evenly; align-items: center;">
              <p class="mb-0 font-weight-bold" style="margin-left: 5rem;">Shift</p>
              <div @click="setToggleBtn" class="toggle-container">
                <span
                  class="toggle-text"
                  :class="{ 'text-left': isMealOpen === 'Open', 'text-right': isMealOpen !== 'Open' }"
                >
                  {{ isMealOpen }}
                </span>
                <div
                  class="toggle-switch"
                  :class="{ 'switch-on': isMealOpen === 'Open', 'switch-off': isMealOpen !== 'Open' }"
                ></div>
              </div>
            </div>

          </div>
          <div class="row px-0">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="openingFields" style="text-align: right;">
                <div class="form-group mb-2 mt-5">
                  <label for="open-time" class="mb-0 font-weight-bold mr-3">Open</label>
                  <input type="time" v-model="openingTime" class="form-control font-weight-bold">
                </div>
                <div class="form-group mb-2">
                  <label for="close-time" class="mb-0 font-weight-bold mr-3">Close</label>
                  <input type="time" v-model="closingTime" class="form-control font-weight-bold">
                </div>
                <div class="form-group mb-2">
                  <label for="time-frequency" class="mb-0 font-weight-bold mr-3">Frequency</label>
                  <select v-model="intervalTime" id="time-frequency" class="form-control font-weight-bold text-center">
                    <option v-for="value in getFrequency()" :key="value" :value="value">
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="position: absolute; bottom: 10px; width: 100%; margin: auto;">
            <div class="col-md-12">
              <button
                class="createSlotBtn"
                @click="createSlots">Create Slots
              </button>
            </div>
          </div>

        </div>
      </div>

      <!-- Time Selectors -->
      <div class="col-md-7 px-0" style="max-width: 61%; flex: 0 0 61%;">
        <div class="section-card" style="background-color: #FFEBD4;display: flex; justify-content: space-between; padding: 16px;">
          <div class="form-group d-flex mb-0" style="align-items: center; justify-content: space-between;">
            <label for="day-status" class="mb-0 font-weight-bold">Maximum guest for each booking</label>
            <select v-model="maxGuestForEachBooking" id="day-status" class="form-control w-75 font-weight-bold text-center">
              <option v-for="(guest, i) in 90" :key="i" :value="guest">{{guest}}</option>
            </select>
          </div>
          <div class="form-group d-flex mb-0" style="align-items: center; justify-content: space-between;">
            <label for="day-status" class="mb-0 font-weight-bold">Maximum guest for the day</label>
            <select v-model="maxGuestForTheDay" id="day-status" class="form-control w-75 font-weight-bold text-center">
              <option v-for="(guest, i) in 90" :key="i" :value="guest">{{guest}}</option>
            </select>
          </div>
        </div>
        <div class="row mx-0" style="max-height: 70vh; overflow-y: scroll;">
          <div class="timeSlots">
            <div class="mx-auto" style="">
              <p v-for="(time, index) in timeSlots" :key="index">{{ time.slot }}</p>
            </div>
          </div>

        </div>
      </div>

      <!-- bottom content -->
       <div style="position: absolute; bottom: -10px; width: 100%; margin: auto; background-color: #FFEBD4;">
        <div class="row mx-0" style="width: 100%;">
          <div class="col-md-6" style="display: flex; align-items: center;">
            <p class="mb-0 ml-5">Add a particular date</p>
            <div class="addDateDiv">
              <input type="date" @change="dateSelected" id="datePicker">
              <!-- <img @click="showCalendarModal = true" src="/img/calendar_red.svg" class="mb-2 pb-3" alt="Calendar"> -->
              <img @click="openCalendar" src="/img/calendar_red.svg" width="60" height="60" class="mb-2" alt="Calendar" style="padding: .5rem .8rem; background-color: #fff; border-radius: 10px;">
              <!-- <p v-if="selectedDate" class="mb-0">{{ selectedDate }}</p> -->
              <!-- <button @click="createDateForTimeSlot" class="btn btnSubmit mt-0 px-5">Add</button> -->
            </div>
          </div>
          <div class="col-md-6 text-right">
            <button @click="updateTableSlot" class="btnSubmit">Save <br> Changes</button>
          </div>
        </div>
       </div>
    </div>

    <div class="modal-vue">
      <!-- overlay -->
      <div class="overlay" v-if="showCalendarModal" @click="showCalendarModal = false"></div>

      <!-- modal -->
      <div class="modal-own" v-if="showCalendarModal">
        <div class="modal-title">
          <h2 class="d-inline font-weight-bold" style="color: rgb(254, 117, 15); margin: unset">Create Date</h2>
          <i class="fa fa-times float-right mr-3" @click="showCalendarModal=false" style="cursor: pointer; color: #fe750f; font-size: 2rem;"></i>

        </div>
        <div class="modal-body">
          <div class="text-center">
            <p class="font-weight-bold">You've selected</p>
            <p v-if="selectedDate" class="mb-0 font-weight-bold">{{ selectedDate }}</p>
          </div>
          <div class="d-flex justify-content-around mt-4">
            <button @click="showCalendarModal = false" class="btnSubmit mt-0 px-5" style="width: 150px;">Cancel</button>
            <button @click="createDateForTableSlot" class="btnSubmit mt-0 px-5" style="width: 150px;">Add</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment'

export default {
  data () {
    return {
      days: [],
      selectedDay: '',
      // isDayOpen: '',
      selectedMeal: [],
      isMealOpen: '',
      openingTime: '',
      closingTime: '',
      intervalTime: '',
      isUpdateAll: false,
      selectedDate: '',
      timeSlots: [],
      jwtToken: this.$cookies.get('token') || null,
      canDeleteSelectedDay: false,
      showCalendarModal: false,
      maxGuestForEachBooking: false,
      maxGuestForTheDay: false,
    }
  },
  mounted() {
    this.getTabelSlots()
  },
  methods: {
    setToggleBtn(){
      this.isMealOpen = this.isMealOpen === 'Open' ? 'Closed' : 'Open'
    },
    getTabelSlots(setFirstDay = true) {
      let url = process.env.VUE_APP_API_URL+'/api/tableSlot/list?restaurantId='+localStorage.getItem('restaurantId')

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${this.jwtToken}`,
          }
        })
        .then((data) => {
          if (data.status == 200) {
            this.days = data.data
            if(setFirstDay){
              this.selectDay(this.days[0])
            } else {
              this.days.forEach(day => {
                if(day.id === this.selectedDay.id) {
                  this.selectDay(day, setFirstDay)
                }
              })
            }
          }
        })
    },
    selectDay(day, setFirstMeal = true) {
      this.selectedDay = day

      if(setFirstMeal){
        this.selectMeal(day.mealOfDays[0])
      } else {
        this.selectedDay.mealOfDays.forEach(meal => {
          if(meal.mealType === this.selectedMeal.mealType) {
            this.selectMeal(meal)
          }
        })
      }
      this.canDeleteSelectedDay = day.weekdays !== 'Yes' ? true : false
    },
    selectMeal(meal) {
      this.selectedMeal = meal;
      this.isMealOpen = meal.hasOpen !== "" ? meal.hasOpen : meal.mealType == 'Evening' ? 'Open' : ''
      this.openingTime = meal.openingTime !== "" ? moment(meal.openingTime, 'hh:mm A').format('HH:mm') : meal.mealType == 'Evening' ? '17:00' : ''
      this.closingTime = meal.closingTime !== "" ? moment(meal.closingTime, 'hh:mm A').format('HH:mm') : meal.mealType == 'Evening' ? '23:00' : ''
      this.maxGuestForEachBooking = meal.maxGuestForEachBooking
      this.maxGuestForTheDay = meal.maxGuestForTheDay
      this.intervalTime = meal.intervalTime !== "" ? meal.intervalTime : meal.mealType == 'Evening' ? 30 : ''
      this.timeSlots = meal.slots
    },
    getFrequency() {
      const options = [];
      for (let i = 5; i <= 60; i += 5) {
        if(60%i === 0)
        options.push(i);
      }
      return options;
    },
    updateTableSlot() {
      let updatePromises = [];

      if (this.isUpdateAll) {
        // Collect all API promises
        updatePromises = this.days.map(day => this.singleDayTableSlotUpdate(day.id));
      } else {
        updatePromises = [this.singleDayTableSlotUpdate(this.selectedDay.id)];
      }

      // Wait for all API calls to finish before calling getTabelSlots()
      Promise.all(updatePromises)
        .then(() => {
          this.getTabelSlots(false);
          this.$toastr.s("Updated successfully", "Success");
        })
        .catch(error => {
          console.error("Error updating time slots:", error);
        });
    },
    async singleDayTableSlotUpdate(id) {
      let url = process.env.VUE_APP_API_URL+'/api/tableSlot/updateTableSlot'

      const data = {
        "id": id,
        "hasWeekDaysOpen": "Open",
        "mealOfDay": {
          "mealType": this.selectedMeal.mealType,
          "hasOpen": this.isMealOpen,
          "openingTime": moment(this.openingTime, 'hh:mm A').format('hh:mm A'),
          "closingTime": moment(this.closingTime, 'hh:mm A').format('hh:mm A'),
          "intervalTime": this.intervalTime,
          "maxGuestForTheDay": this.maxGuestForTheDay,
          "maxGuestForEachBooking": this.maxGuestForEachBooking
        }
      }

      return axios
        .post(url, data, {
          headers: { Authorization: `Bearer ${this.jwtToken}` }
        })
        .then((result) => {})
    },
    openCalendar() {
      let input = document.querySelector("#datePicker");
      input.showPicker();
    },
    dateSelected() {
      let date = document.getElementById("datePicker").value;
      this.selectedDate = moment(date).format("DD/MM/YYYY");
      this.showCalendarModal = true
    },
    createDateForTableSlot() {
      if (this.selectedDate == '') {
        this.$toastr.w("Please select date", "Warning");
        return
      }
      let url = process.env.VUE_APP_API_URL+'/api/tableSlot/create'

      const data = {
        "restaurantId": localStorage.getItem('restaurantId'),
        "name": this.selectedDate
      }

      axios
        .post(url, data, {
          headers: { Authorization: `Bearer ${this.jwtToken}` }
        })
        .then((result) => {
          this.getTabelSlots()
          this.$toastr.s("Date created successfully", "Success");
          this.showCalendarModal = false
        })
    },
    createSlots() {
      let updatePromises = [];

      if (this.isUpdateAll) {
        // Collect all API promises
        updatePromises = this.days.map(day => this.singleDayMealSlotCreate(day.id, false));
      } else {
        updatePromises = [this.singleDayMealSlotCreate(this.selectedDay.id)];
        console.log('updatePromises', updatePromises);

      }

      // Wait for all API calls to finish before calling getTabelSlots()
      Promise.all(updatePromises)
        .then(() => {
          this.getTabelSlots(false);
          this.$toastr.s("Updated successfully", "Success");
        })
        .catch(error => {
          console.error("Error updating time slots:", error);
        });

      // const openTime = moment(this.openingTime, 'hh:mm A').format('hh:mm A');
      // const closeTime = moment(this.closingTime, 'hh:mm A').format('hh:mm A');

      // const url = process.env.VUE_APP_API_URL + `/api/tableSlot/generateSlot?id=${this.selectedDay.id}&mealType=${this.selectedMeal.mealType}&startTime=${openTime} &endTime=${closeTime}&intervalTime=${this.intervalTime}`;
      // axios
      //   .get(url, {
      //     headers: {
      //       Authorization: `Bearer ${this.jwtToken}`,
      //     }
      //   })
      //   .then((data) => {
      //     if (data.status == 200) {
      //       const result = data.data
      //       result.mealOfDays.forEach(meal => {
      //         if(meal.mealType === this.selectedMeal.mealType) {
      //           this.timeSlots = meal.slots
      //         }
      //       })
      //       this.selectedDay = result
      //       for (let i = 0; i < this.days.length; i++) {
      //         if(this.days[i].name === this.selectedDay.name) {
      //           this.days[i] = result
      //         }
      //       }
      //     }
      //   })
    },
    async singleDayMealSlotCreate(id, singleDayUpdate=true) {
      const openTime = moment(this.openingTime, 'hh:mm A').format('hh:mm A');
      const closeTime = moment(this.closingTime, 'hh:mm A').format('hh:mm A');

      const url = process.env.VUE_APP_API_URL + `/api/tableSlot/generateSlot?id=${id}&mealType=${this.selectedMeal.mealType}&startTime=${openTime} &endTime=${closeTime}&intervalTime=${this.intervalTime}`;

      return axios
        .get(url, {
          headers: { Authorization: `Bearer ${this.jwtToken}` }
        })
        .then((data) => {
          if (data.status == 200 && singleDayUpdate) {
            const result = data.data
            result.mealOfDays.forEach(meal => {
              if(meal.mealType === this.selectedMeal.mealType) {
                this.timeSlots = meal.slots
              }
            })
            this.selectedDay = result
            for (let i = 0; i < this.days.length; i++) {
              if(this.days[i].name === this.selectedDay.name) {
                this.days[i] = result
              }
            }
          }
        })
    },
    deleteDate() {
      if(this.selectedDay.weekdays === 'Yes') return

      if (confirm('Are you sure to delete?')){
        let url = process.env.VUE_APP_API_URL+'/api/tableSlot/delete?id='+this.selectedDay.id

        axios
          .get(url, {
            headers: { Authorization: `Bearer ${this.jwtToken}` }
          })
          .then((result) => {
            this.getTabelSlots()
            this.$toastr.s("Date deleted successfully", "Success");
            this.selectedDate = ''
          })
      }
    }
  },
}
</script>
<style scoped>
select{border-radius: 7px;}
.button-container {
  display: flex;
  gap: 0px;
  padding: 10px 15px;
  width: fit-content;
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.button input{width: 15px; height: 15px;}

.day-list {
  overflow-y: scroll;
  padding-bottom: 2rem;
  height: 60vh;
  scrollbar-width: thin;
}
.day-item {
  padding: 10px 15px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  text-align: center;
  margin: .5rem 0;
  cursor: pointer;
  font-weight: bold;
}
.day-item:first-child{margin-top: 0;}
.day-item.active {
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
  font-weight: bold;
}
.section-card {
  background-color: white;
  padding: 20px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.btn-custom {
  border-radius: 20px;
  color: white;
  background: linear-gradient(to right, #ff4500, #ff5733);
  border: none;
}
.btn-custom:hover {
  background: linear-gradient(to right, #ff5733, #ff4500);
}
.mealTypes{
  display: flex;
  justify-content: space-evenly;
}
.mealTypes button{
  width: 29%;
  border: 1px solid;
  margin: 2rem 0;
  background: transparent;
  font-weight: bold;
  padding: 5px 10px;
  color: #000;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.openingFields input, .openingFields select{
  background: transparent;
  border: 1px solid;
  border-radius: 10px;
  padding: 5px;
  width: 50%;
}
.openingFields > .form-group > label, .openingFields > .form-group > input, .openingFields > .form-group > select{
  display: inline-block;
}
.createSlotBtn{
  width: 95%;
  border: unset;
  margin: auto;
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
  font-weight: bold;
  padding: 8px 10px;
  color: #fff;
  display: block;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.btnSubmit{
  border: unset;
  margin-top: .5rem;
  font-weight: bold;
  padding: 8px 10px;
  color: #fff;
  border-radius: 10px;
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
}
.mealTypes button.active{
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
  color: #fff;
  border: unset;
}

#day-status{background-color: transparent;}
#day-status, #lunch-status, #open-time, #close-time, #last-collection, #last-delivery, #time-frequency{
  border: 1px solid #414141;
}
.addDateDiv{text-align: left;}
.addDateDiv img{display: block; margin-left: 1rem;}
#datePicker{opacity: 0; display: block; height: 10px;}
.btnSubmit{
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
  line-height: 1.3rem;
}
.timeSlots{width: 95%; flex: 0 0 95%; margin-left: 1rem; margin-top: 2rem;}
.timeSlots p{
  display: inline-block;
  padding: .4rem 1.7rem;
  background-color: #D5D5D5;
  border-radius: 7px;
  margin: .3rem;
  font-weight: bold;
  width: 95px;
}

.toggle-container {
  position: relative;
  width: 100px;
  height: 35px;
  background-color: #fff;
  border-radius: 10px;
  cursor: pointer;
}

.toggle-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  font-size: 14px;
  transition: all 0.3s ease;
}

.text-left {
  left: 10px;
}

.text-right {
  right: 10px;
}

/* Toggle Switch */
.toggle-switch {
  position: absolute;
  width: 40px;
  height: 35px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.switch-on {
  transform: translateX(60px);
  background: linear-gradient(179.48deg, #FD7902 36.9%, #FF0101 93.77%);
}

.switch-off {
  transform: translateX(0);
  background-color: rgb(176, 174, 174);
}



</style>
